<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue">
          <img :src="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">{{ cart.productInfo.attrInfo.suk }}</div>
          <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'></div>
          <div class="money font-color-red" v-else>{{ cart.truePrice }}</div>

          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>

<!--
        <div class="wrapper" v-if="orderInfo.delivery_type === 'express' && orderInfo.is_stores >= 2">

            <div class="items acea-row row-between">
              <div>配送方式：</div>
              <div class="conter">
                发货
              </div>
            </div>
            <div class="items acea-row row-between" style="margin-top:0.1rem">
              <div>快递公司：</div>
              <div class="conter">{{ cart.delivery_name || "" }}</div>
            </div>
            <div class="items acea-row row-between" style="margin-top:0.1rem">
              <div>快递号：</div>
              <div class="conter">{{ cart.delivery_id || "" }}</div>
            </div>
          <div class="bnt default" v-if="orderInfo.delivery_type === 'express'"
                    @click="
                      $router.push({ path: '/order/logistics/' + orderInfo.order_id})
                    ">
                    查看物流
                  </div>

        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    couponsList:{
      type:Array,
      default:()=>[]
    },
    orderInfo:{
      type:Array,
      default:()=>[]
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
<style >
.order-submission .wrapper .items{padding:0.27rem 0.3rem;font-size:0.3rem;color:#282828;border-bottom:1px solid #f0f0f0;}
.order-submission .wrapper .items .discount{font-size:0.3rem;color:#999;width: 5rem;text-align: right;}
.order-submission .wrapper .items .discount .integral{margin-right: 0.4rem;}
.order-submission .wrapper .items .discount .checkbox-wrapper .icon{right: 0;left: unset;}
.order-submission .wrapper .items .discount .iconfont{color:#515151;font-size:0.3rem;margin-left:0.15rem;}
.order-submission .wrapper .items .discount .num{font-size:0.32rem;margin-right:0.2rem;}
.order-submission .wrapper .items textarea{background-color:#f9f9f9;width:6.9rem;height:1.4rem;border-radius:0.03rem;
    margin-top:0.3rem;padding:0.25rem 0.28rem;}
.order-submission .wrapper .items textarea::placeholder{color:#ccc;}
.order-submission .wrapper .items .list{margin-top:0.35rem;}
.order-submission .wrapper .items .list .payItem{border:1px solid #eee;border-radius:0.06rem;height:0.86rem;width:100%;
    margin-top:0.2rem;font-size:0.28rem;color:#282828;}
.order-submission .wrapper .items .list .payItem.on{border-color:#fc5445;color:#e93323;}
.order-submission .wrapper .items .list .payItem .name{width:30%;text-align:center;border-right:1px solid #eee;}
.order-submission .wrapper .items .list .payItem .name .iconfont{width:0.44rem;height:0.44rem;border-radius:50%;
    text-align:center;line-height:0.44rem;background-color:#fe960f;color:#fff;font-size:0.3rem;margin-right:0.15rem;}
.order-submission .wrapper .items .list .payItem .name .iconfont.icon-weixin2{background-color:#41b035;}
.order-submission .wrapper .items .list .payItem .name .iconfont.icon-yinhangqia{background-color:#eb6623;}
.order-submission .wrapper .items .list .payItem .tip{width:70%;text-align:center;font-size:0.26rem;color:#aaa;}
.wrapper .items .conter{color:#868686;width:4.85rem;text-align:right;}
.wrapper .items .conter .copy{font-size:0.2rem;color:#333;border-radius:0.03rem;border:1px solid #666;
    padding:0.03rem 0.15rem;margin-left:0.24rem;}

  .bnt{
    width: 2rem;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
    border-radius: 0.5rem;
    /* color: #fff; */
    font-size: 0.27rem;
    padding: 0 3%;
    float:right;
    margin-top:0.2rem;
  }
  .bnt.default {
    color: #444;
    border: 1px solid #444
  }
</style>
